import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { TokenStorage } from '../../core/token.storage';
import Api from '../../common/services/api.service';

@Injectable()
export class SignupService {

    
    serviceUrl = 'client/signup';
    validationUrl = 'client/valide';
    passwordUrl = 'client/password';

//serviceUrl = 'http://192.168.1.101:8000/sonavie/client/signup';

    constructor(private api: Api, private token: TokenStorage) { }

    attemptAuth(numSouscript: string, tel: string): Observable<any> {
        const credentials = {numSouscript: numSouscript, tel: tel};
        return this.api.post(this.serviceUrl, credentials); 
    }


    validateAccount(userID: string, password: string,  validationCode: string): Observable<any> {
        const credentials = {numSouscript: userID, pwd: password,  codeWeb: validationCode};
        return this.api.post(this.validationUrl, credentials); 
    }

    password(numSouscript: string): Observable<any> {
        //const credentials = {numSouscript: userID, pwd: password, codeWeb: null};
        const credentials = {numSouscript: numSouscript, tel: null}; 
        
        return this.api.post(this.passwordUrl, credentials); 
    }
}



// WEBPACK FOOTER //
// ./src/app/client-app/services/signup.service.ts